// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const eiscue_noice: PokeData = {
  "id": 10185,
  "name": "eiscue-noice",
  "height": 14,
  "weight": 890,
  "base_experience": 165,
  "types": [
    PokeType.ICE
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "mist",
    "surf",
    "blizzard",
    "amnesia",
    "powder-snow",
    "icy-wind",
    "hail",
    "weather-ball",
    "freeze-dry",
    "aurora-veil",
    "snowscape"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "blizzard",
    "aurora-veil",
    "ice-wave",
    "chilly-reception",
    "ice-shard",
    "sheer-cold",
    "ice-fang",
    "avalanche",
    "hailstorm",
    "ice-punch",
    "icicle-dagger"
  ],
  "evolution_chain": {
    "id": 457,
    "item": null,
    "species": [
      {
        "name": "eiscue",
        "order": 875,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 97,
    "speed": 187,
    "ability_power": 115
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
